<app-sub-menu [subMenus]="subMenus"></app-sub-menu>
<div class="container-fluid bg-box">
  <div class="row">
    <div class="col">
      <h3 *ngIf="revision?.Descripcion; else loadingDescripcion">
        Revision:
        <span style="color: #666f6f">{{ revision?.Descripcion }}</span>
      </h3>
      <ng-template #loadingDescripcion>
        <h3 class="d-flex">
          Revision:
          <div class="skeleton p-2 ml-2 rounded w-50"></div>
        </h3>
      </ng-template>
    </div>
    <div class="col text-right">
      <h3 *ngIf="global?.userSesion?.Roles[0]?.IdRol; else loadingRolEtapa">
        Rol {{ global.userSesion?.Roles[0].IdRol }} etapa
        {{ revision?.IdEtapa }}
      </h3>
      <ng-template #loadingRolEtapa>
        <h3>Rol _ etapa _</h3>
      </ng-template>
      <button *ngIf="global.userSesion?.Roles[0].IdRol == 5 && revision?.IdEtapa == 5" (click)="Downloadinforme()"
        class="btn btn-sm btn-info mr-1" type="button">
        <i class="fa fa-download"></i> Descargar informe
      </button>

      <button *ngIf="revision?.IdEtapa == 5" (click)="conclusion()" class="btn btn-sm btn-info mr-1" type="button">
        <i class="fa fa-file"></i> Generar informe final
      </button>

      <button *ngIf="
          (global.userSesion?.Roles[0].IdRol == 3 ||
            global.userSesion?.Roles[0].IdRol == 5) &&
          [3, 4].includes(revision?.IdEtapa)
        " (click)="conclusionPreliminar()" class="btn btn-sm btn-success mr-1" type="button">
        <i class="fa fa-file"></i> Generar informe preliminar
      </button>
      <button [disabled]="btnRefresh" (click)="refresh()" class="btn btn-sm btn-primary" type="button">
        <i class="fa fa-sync"></i> Actualizar
      </button>

      <button *ngIf="finalizar" (click)="terminarRevision()" class="btn btn-sm btn-primary" type="button">
        <i class="fa fa-sync"></i> Terminar revisón
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <h6 *ngIf="checklist?.Calificacion || checklist?.Calificacion > -1; else loadingCalificacion">
        Calificación: <span>{{ checklist?.Calificacion }}</span>
      </h6>
      <ng-template #loadingCalificacion>
        <h6 class="d-flex">
          Calificación:
          <div class="skeleton p-2 ml-1 rounded" style="width: 3rem"></div>
        </h6>
      </ng-template>
    </div>
  </div>
  <hr />
  <div class="row">
    <div class="col-12">
      <div *ngIf="checklist?.Bloques; else loading" class="accordion" id="accordionExample">
        <app-bloque [global]="global" [bloque]="bloque" *ngFor="let bloque of checklist?.Bloques"></app-bloque>
      </div>
      <ng-template #loading>
        <div class="skeleton mt-1 h-auto p-5 rounded"></div>
      </ng-template>
    </div>
  </div>
</div>

<div class="modal fade" id="modalMotivo" tabindex="-1" role="dialog" data-bs-backdrop="static" aria-labelledby="modalEditLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="modalEditLabel">Motivo de rechazo</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form id="frmPostRechazoRubro" (submit)="frmPostRechazoRubro($event)" ngNativeValidate>
        <div class="modal-body">
          <div class="form-group">
            <label>Ingrese un motivo de rechazo:</label>
            <textarea id="motivoText" required class="form-control" rows="5" maxlength="256"></textarea>
          </div>
        </div>
        <div class="modal-footer">
          <button [disabled]="btnRubroRechazo" type="submit" class="btn btn-primary primary">
            Rechazar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="modalEvidencia" tabindex="-1" role="dialog" aria-labelledby="modalEditLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <img style="height: 500px; cursor: pointer" class="img-thumbnail" id="imgEvidencia" (click)="bigEvidencia()" />
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalEvidenciaVideo" tabindex="-1" role="dialog" aria-labelledby="modalEditLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body text-center">
        <video id="video" style="width: 400px; height: 400px" preload="none" controls autoplay></video>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalListMotivo" tabindex="-1" role="dialog" aria-labelledby="modalEditLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <div class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">Consecutivo</th>
                <th scope="col">Motivo de rechazo</th>
                <th scope="col">Empleado rechazó</th>
                <th scope="col">Fecha de rechazo</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rechazo of listRechazos">
                <td>{{ rechazo.Consecutivo }}</td>
                <td style="text-align: left" [innerHTML]="replaceSaltoHTML(rechazo.MotivoRechazo)"></td>
                <td>{{ rechazo.EmpleadoRechazo }}</td>
                <td>{{ datetimeToDateFormat(rechazo.FechaAlta, true) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalHistorial" tabindex="-1" role="dialog" aria-labelledby="modalmodalHistorial"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body text-center">
        <div *ngIf="listHistorico.length == 0">
          <p>No existe historial para este rubro.</p>
        </div>
        <div *ngIf="listHistorico.length > 0" class="table-responsive">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">Empleado</th>
                <th scope="col">Rol</th>
                <th scope="col">Estatus</th>
                <th scope="col">Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let historico of listHistorico">
                <td>{{ historico.EmpleadoValido }}</td>
                <td>{{ historico.RolValido }}</td>
                <td>{{ historico.Estatus }}</td>
                <td>
                  {{ datetimeToDateFormat(historico.FechaValidacion, true) }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalObservaciones" tabindex="-1" role="dialog" aria-labelledby="modalObservacionesLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content" style="display: inline-block">
      <div class="modal-header">
        <h5 class="modal-title" id="modalObservacionesLabel">
          Captura una observación
        </h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form id="frmPostObservacion" (submit)="frmPostObservacion($event)">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <textarea name="observaciones" id="observaciones" class="form-control" rows="12"
                [(ngModel)]="txtObservaciones" maxlength="1024"></textarea>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-sm btn-primary" [disabled]="txtObservaciones?.length < 5">
            <i class="fa fa-save"></i> Guardar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="modalAcciones" tabindex="-1" role="dialog" aria-labelledby="modalAccionesLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalAccionesLabel">
          Captura las acciones del rubro
        </h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-crud [config]="configCrudAcciones"></app-crud>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalConclusion" tabindex="-1" role="dialog" aria-labelledby="modalConclusionLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalConclusionLabel">Conclusión.</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <figure class="text-center">
              <blockquote class="blockquote">
                <p>
                  Registra una conclusión para poder generar el informe final.
                </p>
              </blockquote>
            </figure>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <textarea [class.disabled-resize]="revision?.IdEtapa == 5" [disabled]="revision?.IdEtapa == 5"
              class="form-control" name="txtConclusion" id="txtConclusion" rows="5"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="revision?.IdEtapa == 5" (click)="updateConclusion()" class="btn btn-sm btn-info mr-1"
          type="button">
          <i class="fa fa-file"></i> Generar.
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalConclusionPreliminar" tabindex="-1" role="dialog"
  aria-labelledby="modalConclusionPreliminarLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalConclusionPreliminarLabel">
          Conclusión.
        </h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <figure class="text-center">
              <blockquote class="blockquote">
                <p>
                  Registra una conclusión para generar el informe preliminar.
                </p>
              </blockquote>
            </figure>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <textarea [class.disabled-resize]="revision?.IdEtapa == 5" [disabled]="revision?.IdEtapa == 5"
              class="form-control" name="txtConclusion" id="txtConclusionPreliminar" rows="5"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="
            global.userSesion?.Roles[0].IdRol == 3 &&
            [3, 4].includes(revision?.IdEtapa)
          " (click)="updateConclusionPreliminar()" class="btn btn-sm btn-info mr-1" type="button">
          <i class="fa fa-file"></i> Guardar.
        </button>
      </div>
    </div>
  </div>
</div>